export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-folder-add-f0d632c91523c989a4825aa48f2e1565.svg";